import { createSelector } from '@reduxjs/toolkit';
import {
  AutomatedNotesScheduleOutputDto,
  DashboardDatasetConfigOutputDto,
} from '@kortxio/hub-api';
import { AdminCampaignRow } from 'features/admin-campaigns/helper';
import { AdminCampaignsState } from 'features/admin-campaigns/types';
import { isAwaitingData } from 'features/shared/request';
import { RootState } from 'store/types';

const adminCampaignsRootSelector = (state: RootState): AdminCampaignsState =>
  state.adminCampaigns;

export const adminCampaignsDataSelector = createSelector(
  adminCampaignsRootSelector,
  (adminCampaignsRoot): AdminCampaignRow[] | undefined =>
    adminCampaignsRoot.campaigns.data
);

export const adminCampaignsIsLoadingSelector = createSelector(
  adminCampaignsRootSelector,
  (adminCampaignsRoot): boolean => isAwaitingData(adminCampaignsRoot.campaigns)
);

export const adminDatasetsDataSelector = createSelector(
  adminCampaignsRootSelector,
  (root): DashboardDatasetConfigOutputDto[] | undefined => root.datasets.data
);

export const adminSchedulesDataSelector = createSelector(
  adminCampaignsRootSelector,
  (root): AutomatedNotesScheduleOutputDto[] | undefined => root.schedules.data
);
